export default __webpack_public_path__ + "static/yahoo-finance-logo-385b662b2d104f2f6b7f3ac3d19c6197.png";